import { Component, OnInit } from '@angular/core';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { VersionCheckService } from './services/VersionCheckService';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(
    private primengConfig: PrimeNGConfig,
    private versionCheck: VersionCheckService,
    private messageService: MessageService,
  ) {}

  ngOnInit() {
    if (environment.production) {
      this.versionCheck.initVersionCheck(5);
    }

    this.primengConfig.setTranslation({
      dayNames: ["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"],
      dayNamesShort: ["вск","пнд","втр","срд","чтв","птн","сбт"],
      dayNamesMin: ["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],
      monthNames: ["январь","февраль","март","апрель","май","июнь","июль","август","сентябрь","октябрь","ноябрь","декабрь"],
      monthNamesShort: ["янв","фев","мар","апр","май","июн","июл","авг","сен","окт","ноя","дек"],
      today: 'Сегодня',
      clear: 'Очистить',
      dateFormat: 'dd.mm.yy',
      firstDayOfWeek: 1,
    });
  }

  onUpdateClick(): void {
    this.versionCheck.reload();
  }

  onDismissUpdate(message: any): void {
    this.messageService.clear(message?.key ?? 'app-update');
  }
}
